module.exports = __webpack_public_path__ + "static/media/robots.bbbcde0b.txt";